import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "engineAlias",
})
export class EngineAliasPipe implements PipeTransform {
  transform(value: any): any {
    return value == 1 ? "البحري" : "القبلي";
  }
}
